import axios, { type AxiosResponse } from "axios";
import { KnowledgeBaseArticleSchema, KnowledgeBaseArticleReactionSchema } from "@/schemas/index";
import type {
  KnowledgeBaseArticleType,
  KnowledgeBaseArticleReactionType,
} from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceKnowledgeBaseApiType {
  fetchArticleByNumber: (number: string) => Promise<KnowledgeBaseArticleType>;
  fetchArticleReaction: (
    id: KnowledgeBaseArticleType["Id"],
  ) => Promise<KnowledgeBaseArticleReactionType>;
  postArticleLike: (id: KnowledgeBaseArticleType["Id"]) => Promise<void>;
  postArticleDislike: (id: KnowledgeBaseArticleType["Id"]) => Promise<void>;
  postArticleView: (id: KnowledgeBaseArticleType["Id"]) => Promise<void>;
}

export const serviceKnowledgeBaseApi: ServiceKnowledgeBaseApiType = {
  fetchArticleByNumber: (number) => {
    return axios
      .get(`${env.services.portal}/kb/articles/${number}`)
      .then((response: AxiosResponse<unknown>) => {
        return KnowledgeBaseArticleSchema.parse(response.data);
      });
  },

  fetchArticleReaction: (id) => {
    return axios
      .get(`${env.services.portal}/kb/articles/${id}/reaction`)
      .then((response: AxiosResponse<unknown>) => {
        return KnowledgeBaseArticleReactionSchema.parse(response.data);
      });
  },

  postArticleLike: (id) => {
    return axios.post(`${env.services.portal}/kb/articles/${id}/like`);
  },

  postArticleDislike: (id) => {
    return axios.post(`${env.services.portal}/kb/articles/${id}/dislike`);
  },

  postArticleView: (id) => {
    return axios.post(`${env.services.portal}/kb/articles/${id}/view`);
  },
};
